import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import ArrowBack from 'material-ui/svg-icons/navigation/arrow-back';
import firebase from '../firebase';
import compose from '../compose';
import user from '../Auth/user';
import { translate } from 'react-i18next';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import createHistory from 'history/createBrowserHistory';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class Settings extends React.Component {
  handleLanguageChange = (event, index, language) => {
    const {firebase} = this.props;
    firebase.database().ref(`users/${this.props.user.userId}/language`).set(language);
  }

  render()  {
    const {t} = this.props;

    return (
      <Card className='cardStyle' >
          <Toolbar>
            <ToolbarGroup firstChild={true}>
              <IconButton onTouchTap={createHistory().goBack}>
                <ArrowBack color="rgba(0,0,0,0.4)" />
              </IconButton>
              <ToolbarTitle text={t('settings')} />
            </ToolbarGroup>
          </Toolbar>
          <CardText>
            <SelectField
              autoWidth={true}
              floatingLabelText={t('language')}
              value={this.props.user.language}
              onChange={this.handleLanguageChange}>
              <MenuItem value={'en'} primaryText="English" />
              <MenuItem value={'fi'} primaryText="Suomi" />
            </SelectField>
          </CardText>
        </Card>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(Settings);



// WEBPACK FOOTER //
// ./src/Navigation/Settings.js